import React, { Component, Fragment } from 'react'
import { Label } from 'atoms/Texts'
import { Severities, ConformityLocations } from 'fixtures/enums'
import { ButtonReg } from 'atoms/Buttons'
import { FormTxt, FormSelect, FormTxtArea, FormTypeahead, FormChipsSearch, FormCheck } from 'atoms/Inputs'
import MapView from 'atoms/MapView'
import GridPhotos from 'molecules/GridPhotos'
import BtnGrouped from 'molecules/BtnGrouped'
import SectionInput from 'molecules/SectionInput'
import CoordinateField from 'molecules/CoordinateField'
import { DateInput, TimeInput } from 'molecules/DateTimeInput'
import {
  MainWrapper,
  ModalHead,
  ModalFooter,
  LevelRowContainer,
  SectionRow,
  CheckboxWrapper,
  RequiredSign
} from '../styles'
import { withTheme } from 'styled-components'

class ConformityReportModal extends Component {
  state = {
    showPreview: false,
  }

  inputConfig = {
    border: this.props.theme.mocaGrey,
    rad: '6px',
    width: '100%',
    yxPadding: '9px 12px',
    height: '34px',
  }

  renderPicker(label, field, lookupField, nameField, valField = 'id') {
    const { fnChange, deptsList, lookups, newTaskData } = this.props
    return (
      <Fragment>
        <Label lineheight={'14px'} size={'12px'}>
          {label}
          <RequiredSign>&nbsp;*</RequiredSign>
        </Label>
        <FormSelect
          placeholder={`Select ${label}`}
          onChangeVal={e => fnChange(e.target.value, field)}
          options={lookupField === 'location' ? ConformityLocations : field === 'concernedDepartment' ? deptsList : lookups[lookupField]}
          value={newTaskData[field]}
          valField={field === 'seam' ? 'seam' : field === 'concernedDepartment' ? 'name' : valField}
          dispField={field === 'concernedDepartment' ? 'nameDisplay' : nameField}
          arrowSize={'16px'}
          {...this.inputConfig}
        />
      </Fragment>
    )
  }

  render() {
    const { lookups, newTaskData, isDisabled, isSubmitted, fnChange, fnSubmit, fnSwitch, handleSearchCC, ccsList } = this.props

    return (
      <MainWrapper>
        <ModalHead>
          <Label lineheight={'29px'} size={'24px'} mb={'0px'}>
            New Unconformity
          </Label>
        </ModalHead>
        <LevelRowContainer>

          <div className={'row col-12 mx-0 px-0 mb-3'}>
            <div className={'col-6 px-0 pr-2'}>
              {this.renderPicker('Contractor', 'contractorId', 'contractors', 'name')}
            </div>
            <div className={'col-6 px-0'}>
              {this.renderPicker('Pit', 'pitId', 'pits', 'name')}
            </div>
          </div>

          {newTaskData.pitId !== '-' ?
            <Fragment>
              <div className={'row col-12 mx-0 px-0 mb-3'}>
                <div className={'col-12 px-0 mb-3'}>
                  {this.renderPicker('Category', 'conformityCategoryId', 'categories', 'conformityCategoryName', 'conformityCategoryId')}
                </div>
                <div className={'col-12 px-0'}>
                  <Label lineheight={'14px'} size={'12px'}>
                    Title
                    <RequiredSign>&nbsp;*</RequiredSign>
                  </Label>
                  <FormTxt
                    placeholder={'Enter request title'}
                    mb={'16px'}
                    value={newTaskData.title}
                    onChangeVal={e => fnChange(e.target.value, 'title')}
                    {...this.inputConfig}
                  />
                </div>
                <div className={'col-12 px-0'}>
                  <Label lineheight={'14px'} size={'12px'}>
                    Description
                    <RequiredSign>&nbsp;*</RequiredSign>
                  </Label>
                  <FormTxtArea
                    placeholder={'Enter description'}
                    value={newTaskData.description}
                    onChangeVal={e => fnChange(e.target.value, 'description')}
                    {...this.inputConfig}
                  />
                </div>
              </div>

              <div className={'row col-12 mx-0 px-0 mb-3'}>
                <div className={'col-5 px-0 pr-2'}>
                  <Label lineheight={'14px'} size={'12px'}>
                    Severity
                    <RequiredSign>&nbsp;*</RequiredSign>
                  </Label>
                  <BtnGrouped
                    li={Severities}
                    sel={newTaskData.severity}
                    fn={fnChange}
                    field={'severity'}
                  />
                </div>
                <div className={'col-6 px-0 pr-2'}>
                  <Label lineheight={'14px'} size={'12px'}>
                    Position
                    <RequiredSign>&nbsp;*</RequiredSign>
                  </Label>
                  <CoordinateField
                    pos={newTaskData.position}
                    field={'position'}
                    fn={fnChange}
                  />
                </div>
                <div className={'col-1 px-0 pr-2 align-self-end'}>
                  <ButtonReg 
                    onClick={() => this.setState(prev => ({ showPreview: !prev.showPreview }))} 
                    btnIcon={'map'} 
                    bg="#463291" 
                    width="100%"
                    height="2.1rem"
                  />
                </div>
              </div>

              {this.state.showPreview && newTaskData.position &&
                <div className={'row col-12 mx-0 px-0 mb-3'}>
                  <MapView
                    pos={newTaskData.position}
                    field={'position'}
                    fn={fnChange}
                    selectable={true}
                  />
                </div>
              }

              <div className={'row col-12 mx-0 px-0 mb-3'}>
                <div className={'col-6 px-0 pr-2'}>
                  {this.renderPicker('Location', 'location', 'location', 'label', 'value')}
                </div>
                <div className={'col-6 px-0 pr-2'}>
                  <Label lineheight={'14px'} size={'12px'}>
                    Time Occurence
                    <RequiredSign>&nbsp;*</RequiredSign>
                  </Label>
                  <TimeInput
                    val={newTaskData.timeOccurence}
                    fn={fnChange}
                    field={'timeOccurence'}
                    config={this.inputConfig}
                  />
                </div>
              </div>

              <div className={'row col-12 mx-0 px-0 mb-3'}>
                <div className={'col-12 px-0 mb-3'}>
                  <Label lineheight={'14px'} size={'12px'}>
                    Type
                    <RequiredSign>&nbsp;*</RequiredSign>
                  </Label>
                  <FormTypeahead
                    placeholder={'Select type'}
                    options={lookups.types || []}
                    dispField={'nameDisplay'}
                    control={newTaskData.locationType ? [newTaskData.locationType] : []}
                    onChangeVal={e => fnChange(e, 'locationType')}
                    {...this.inputConfig}
                  />
                </div>
                <div className={'col-12 px-0'}>
                  <Label lineheight={'14px'} size={'12px'}>
                    Root Cause
                    <RequiredSign>&nbsp;*</RequiredSign>
                  </Label>
                  <FormTxtArea
                    placeholder={'Enter cause'}
                    value={newTaskData.rootCause}
                    onChangeVal={e => fnChange(e.target.value, 'rootCause')}
                    {...this.inputConfig}
                  />
                </div>
              </div>

              <div className={'row col-12 mx-0 px-0 mb-3'}>
                <div className={'col-12 px-0 pr-2 mx-0 mb-1'}>
                  <CheckboxWrapper>
                    <FormCheck
                      value={!newTaskData.hideSeamAndSection}
                      fn={() => fnChange(!newTaskData.hideSeamAndSection, 'hideSeamAndSection')}
                      className={'mr-2'}
                      allowEdit
                    />
                    <Label
                      onClick={() => fnChange(!newTaskData.hideSeamAndSection, 'hideSeamAndSection')}
                      lineheight={'12px'}
                      size={'12px'}
                      mt={'3px'}
                    >
                      Need Coal Check
                    </Label>
                  </CheckboxWrapper>
                </div>
                {
                  !newTaskData.hideSeamAndSection && (
                    <>
                      <div className={'col-6 px-0 pr-2'}>
                        {this.renderPicker('Seam', 'seam', 'seams')}
                      </div>
                      <div className={'col-6 px-0 pr-2'}>
                        <Label lineheight={'14px'} size={'12px'}>
                          Section
                          <RequiredSign>&nbsp;*</RequiredSign>
                        </Label>
                        <SectionRow>
                          <Label lineheight={'14px'} size={'12px'} mb={'0'}>
                            {newTaskData.sectionPrefix}
                          </Label>
                          <SectionInput
                            val={newTaskData.sectionFrom}
                            fn={fnChange}
                            field={'sectionFrom'}
                          />
                          <SectionInput
                            val={newTaskData.sectionTo}
                            fn={fnChange}
                            field={'sectionTo'}
                          />
                        </SectionRow>
                      </div>
                    </>
                  )
                }
              </div>

              <div className={'row col-12 mx-0 px-0 mb-3'}>
                <Label lineheight={'14px'} size={'12px'}>
                  Due Date
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <DateInput
                  val={newTaskData.dateDeadline}
                  fn={fnChange}
                  field={'dateDeadline'}
                  config={this.inputConfig}
                />
              </div>

              <div className={'row col-12 mx-0 px-0 mb-3'}>
                <div className={'col-12 px-0'}>
                  <Label lineheight={'14px'} size={'12px'}>
                    Photos
                  </Label>
                  <GridPhotos
                    photos={newTaskData.photo}
                    isAbleToAdd={true}
                    inputId={'pickPhoto'}
                    largeMode
                    previewOnClick
                  />
                </div>
              </div>

              {newTaskData.pitId && <div className={'row col-12 mx-0 px-0 mb-3'}>
                <div className={'col-12 px-0 pr-2'}>
                  <Label lineheight={'14px'} size={'12px'}>
                    Cc
                  </Label>
                  <FormChipsSearch
                    control={newTaskData.cc}
                    placeholder="Search Username"
                    dispField="displayName"
                    minLength={0}
                    onSearch={e => handleSearchCC(e)}
                    options={ccsList.data || []}
                    isLoading={ccsList.isLoading}
                    onChangeVal={e => fnChange(e, 'cc')}
                  />
                </div>
              </div>}

              {newTaskData.anyFurtherAction &&
                <div className={'row col-12 mx-0 px-0 mb-3'}>
                  <div className={'col-12 px-0'}>
                    <Label lineheight={'14px'} size={'12px'}>
                      Describe the action needed
                      <RequiredSign>&nbsp;*</RequiredSign>
                    </Label>
                    <FormTxtArea
                      placeholder={'Enter description'}
                      value={newTaskData.furtherActionDescription}
                      onChangeVal={e => fnChange(e.target.value, 'furtherActionDescription')}
                      {...this.inputConfig}
                    />
                  </div>
                </div>
              }

              <div className={'col-12 px-0'}>
                {this.renderPicker('Concerned Department', 'concernedDepartment', 'depts', 'nameDisplay', 'name')}
              </div>
            </Fragment> :
            <div>Select any pit to continue.</div>
          }

          <ModalFooter>
            <RequiredSign pos={'c'}>&nbsp;*Required field</RequiredSign>
            <ButtonReg onClick={fnSwitch} btnTxt={'Cancel'} transparent />
            <ButtonReg onClick={fnSubmit} disabled={isDisabled || isSubmitted} className={'ml-2'} btnTxt={isSubmitted ? 'Submitting...' : 'Submit'} />
          </ModalFooter>

        </LevelRowContainer>
      </MainWrapper>
    );
  }
}

export default withTheme(ConformityReportModal);
